<template lang="pug">
el-container(style="height: 100vh" direction="vertical")
  publicHeader
  
  el-main
    .terms
      h1 {{ $t('footer_menus.terms') }}
      
      h2 第１条（目的）
      p 本規約は、株式会社コノル(以下、「当社」といいます。)が製造するIoT端末CUONAを利用したサービスをお客様が受けるにあたって必要な携帯端末上アプリ又はWEBサイトの使用に関する条件を定めるものです。

      h2 第2条（定義）
      p 本規約において用いる主要な用語を以下のとおり定義します。
      ol
        li  「お客様」とは、本サービスの利用を希望する又は本サービスを利用する個人又は法人を意味します。
        li 「携帯端末」とは、本サービスを利用するための、スマートフォン・タブレット等の携帯機器を意味します。
        li 「本商品」とは、ホテル、カフェ、イベント等の店舗内外に設置し、お客様の携帯端末と近距離無線通信（NFC）で個体を特定し、無線通信(Bluetooth®,Wi-Fi)によりデータのやり取りを行うIoT端末「CUONA」を意味します。
        li 「本サービス」とは、当社が製造する本商品を利用する事業分析又は業務効率化等を目的としたサービスを意味します。
        li 「利用契約」とは、第5条の定めにより成立する本サービスの利用に関する権利義務関係を内容とする契約を意味します。
        li 「ユーザ登録」とは、本サービス利用の前提として、当社が別途指定するお客様に関する情報を当社に提供いただくことを意味します。
        li 「管理画面」とは、お客様がユーザ登録において設定されたメールアドレスとパスワードをもって、本サービスを利用するにあたって各種設定や情報の閲覧をするためのWEBページを意味します。
        li 「本サービス用設備」とは、当社が本サービスの提供のために利用するコンピュータ、サーバ、ミドルウェア、電気通信設備その他の機器及びソフトウェアを意味します。
        li 「プラットフォーム」とは、当社が本サービスを販売するために利用するWebサービス（GooglePlay®、AppStore®など本サービスが購入できるWebサービスを含みますがそれらに限られません。）等を意味します。
        li 「知的財産権等」とは、著作権（著作権法第27条及び第28条に定める権利を含みます。）、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）及びノウハウを意味します。

      h2 第3条（通知）
      ol
        li 本規約において定める当社からお客様への通知方法は、利用契約に特段の定めのない限り、通知内容を電子メール、書面、管理画面への表示、当社ホームページへの掲載など、当社が適当と判断する方法により行います。
        li 前項の規定に基づき、当社からお客様への通知を電子メール、管理画面への表示又は当社ホームページへの掲載の方法により行う場合には、お客様に対する当該通知は、それぞれ電子メールの送信、管理画面への表示又は当社ホームぺージへの掲載がなされた時点から効力を生じるものとします。
      
      h2 第4条（ユーザ登録）
      ol
        li お客様は、本サービスを利用するためにユーザ登録が必要となります。ユーザ登録のために当社が別途指定する情報を当社に提供して頂く必要があります。
        li お客様は、ユーザ登録の際に真実かつ正確で最新の情報を当社に提供しなければならないものとします。
        li 本サービスの利用契約が解除又は別途当社指定する方法により解約された場合、当該時点以降、当社は登録された情報を継続して保有する義務を負わないものとします。

      h2 第5条（利用契約の締結等）
      ol
        li 利用契約は、お客様が本規約の内容に同意した上で前条のユーザ登録を行ったときに成立するものとします。なお、お客様は、ユーザ登録を行った場合、本規約に同意したものとみなされます。
        li 前項の定めに拘わらず、お客様が次の各号のいずれかに該当することがユーザ登録日から１ヶ月以内に判明した場合、当社のお客様への通知をもって利用契約は遡及的に不成立とみなします。
          ol
            li ① 過去に当社との何らかの契約が解除されたことがある場合
            li ② 利用申込又は利用変更申込に虚偽、誤記又は記入漏れがある場合
            li ③ 金銭債務その他利用契約に基づく債務の履行を怠るおそれがあると当社が判断した場合
            li ④ お客様が本サービスと同様又は類似の製品・サービスを提供するおそれ又はしている場合
            li ⑤ 反社会的勢力、性風俗、マルチ商法、その他当社において不相当と判断される事業を直接又は間接に運営している場合
            li ⑥ その他当社が不適当と判断した場合
        li お客様の事情で利用契約の変更を行う場合、お客様は当社所定の変更申込を当社に行い（当社ホームページ又は本サービス内の変更申込画面上において入力・送信する方法を含み、以下同じとします。）、当社がこれに承諾したときに利用契約の変更がなされるものとします。
        li 当社は、利用契約の内容である本規約について、随時追加・変更・削除することがあります。なお、この場合には、お客様の利用条件の内容は、変更後の利用規約を適用するものとします。
        li 前項の本規約の変更は、当社が別途定める場合を除き、電子メール、書面、管理画面への表示、当社ホームページへの掲載のいずれかに変更後の内容を通知又は表示した後１週間の経過をもってその効力を生じるものとします。なお、お客様は当該期間の経過後の本サービスの利用により当該変更に同意したものとみなされます。
        li 当社は、前各項その他本規約の規定にかかわらず、当社の判断により利用契約又は利用変更契約を締結しないことができます。この場合の不締結の理由は非公開とします。
      
      h2 第6条（本サービスの内容）
      p 本サービスの内容の詳細は、当社ホームページ（
        a(href="https://cuona.io/") https://cuona.io/
        | ）に記載するものとします。

      h2 第7条（本サービス利用のための設定・維持）
      ol
        li 本サービスを利用する前提として、本サービスに関連するデータをダウンロードするためのインターネット接続環境、本商品と通信を行うために必要となるBluetooth® に対応した携帯端末をお客様の責任で準備して頂くものとします。
        li 本サービスを利用するために必要となる本商品は、お客様の費用と責任で当社又は当社と契約する販売店（以下、「販売店」といいます。）から購入又はレンタルするものとします。

      h2 第8条（利用料金の支払い義務）
      ol
        li 本サービスの利用料金は、別途当社又は販売店がお客様に提示する利用料金表に定めるとおりとします。
        li お客様は、利用期間中、利用料金表に定める利用料金及びこれにかかる消費税等を当社、または販売店が別途指定する支払時期・支払方法で支払うものとします。なお、お客様が本条に定める支払を完了しない場合、当社は、本サービスの提供を行わないことができるものとします。
        li 利用期間において、第12条第1項各号に定める本サービスの提供の中断、停止その他の事由により本サービスを利用することができない状態が生じたときであっても、当社、または販売店は、一旦支払いをうけた利用料金について如何なる理由かを問わず一切返還しないものとします。

      h2 第9条（パスワードの管理）
      ol
        li 本サービスの利用に際して、お客様がユーザ登録において設定されたメールアドレスとパスワードを用いて認証を行います。
        li お客様は、パスワードの認証情報を第三者に開示、貸与、共有しないとともに、第三者に漏洩することのないよう厳重に管理（パスワードの適宜変更を含みます。）する義務を負います。パスワードの認証情報の管理不備、使用上の過誤、第三者の使用等によりお客様自身及びその他の第三者が損害を被った場合、当社は一切の責任を負わないものとします。お客様のメールアドレス及びパスワードによる本サービスの利用その他の行為は、全てお客様による利用とみなすものとされ、お客様はかかる利用についての利用料金の支払その他の債務一切を負担するものとします。

      h2 第10条（当社からの利用契約の解除等）
      ol
        li 当社は、お客様が次の各号のいずれかに該当すると判断した場合、お客様への事前の通知又は催告を要することなく利用契約の全部又は一部を解除することができるものとします。
          ol
            li ① 本規約の内容含め利用契約に違反した場合
            li ② 利用申込、利用変更申込その他通知内容等に虚偽記入又は記入漏れがあった場合
            li ③ 支払停止又は支払不能となった場合
            li ④ 手形又は小切手が不渡りとなった場合
            li ⑤ 差押え、仮差押えもしくは競売の申立があったとき又は公租公課の滞納処分を受け  た場合
            li ⑥ 破産、会社更生手続開始もしくは民事再生手続開始の申立があったとき又は信用状  態に重大な不安が生じた場合
            li ⑦ 監督官庁から営業許可の取消、停止等の処分を受けた場合
            li ⑧ 解散、減資、事業の全部又は重要な一部の譲渡等の決議をした場合
            li ⑨ 本サービスと同様又は類似のサービスを現に提供している場合又は将来行う予定が  あることが判明した場合
            li ⑩ 反社会的活動を行っている場合その他反社会的勢力に該当する場合もしくはこれら  と関連がある場合
            li ⑪ その他利用契約を履行することが困難となる事由が生じたと当社が判断した場合
        li お客様は、前項各号の事由に該当した場合、当社に対して負っている債務の一切について期限の利益を失い、前項による利用契約の解除又は停止があった時点において未払いの利用料金又は遅延損害金がある場合には、直ちにこれを一括にて支払わなければならないものとします。

      h2 第11条（禁止事項）
      p 当社は、お客様が本サービスの利用にあたって、以下の各号に該当する行為又は該当すると当社が判断する行為を行うことを禁止します。
      ol
        li 法令に違反する行為又は犯罪行為に関連する行為
        li 当社、本サービスの他のお客様又はその他の第三者に対する詐欺又は脅迫行為
        li 公序良俗に反する行為
        li 当社、本サービスのお客様又はその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為
        li 本サービスのネットワーク又はシステム等に過度な負荷をかける行為
        li 本サービスの運営を妨害するおそれのある行為
        li 本サービス又は本商品のリバースエンジニアリング等の解析行為
        li 当社のネットワーク又はシステムもしくは本商品に不正にアクセスし、又は不正なアクセスを試みる行為
        li 第三者に成りすます行為
        li 当社が許諾していない本サービス上での宣伝、広告、勧誘、又は営業行為
        li 本サービスの他のお客様又はその他の第三者に不利益、損害、不快感を与える行為
        li 反社会的勢力、性風俗、マルチ商法、その他当社において不相当と判断される事業の直接的又は間接的な運営
        li 反社会的勢力等への利益供与
        li 当社の同意なく、本サービス又は本商品の再頒布、貸与、販売をする行為
        li 日本国内での適法性に疑義のあるサービスに利用することその他当社が不適切と判断する行為

      h2 第12条（一時中断及び提供停止）
      ol
        li 当社は、次の各号のいずれかに該当する場合には、お客様への事前の通知又は承諾を要することなく、本サービスの提供を中断することができるものとします。
          ol
            li ① 本サービス用設備の保守を定期的に又は緊急に行う場合
            li ② 天災地変、停電、戦争、暴動、騒乱、労働争議その他の不可抗力により本サービス等の提供ができなくなった場合
            li ③ 電気通信事業者等が電気通信サービスの提供を中止又は停止することにより本サービスの提供ができなくなった場合
            li ④ プラットフォーム側の事情により本サービスの提供ができなくなった場合
            li ⑤ その他、運用上或いは技術上当社が本サービスの中断を必要と判断した場合
        li 当社は、お客様が第10条第１項各号のいずれかに該当する場合には、お客様への事前の通知もしくは催告を要することなく本サービスの全部又は一部の提供を停止することができるものとします。
        li 当社は、前各項に定める事由のいずれかにより本サービスを提供できなかったことに関してお客様又はその他の第三者が損害を被った場合であっても、一切責任を負わないものとします。

      h2 第13条（本サービスの廃止）
      p 当社は、次の各号のいずれかに該当する場合、本サービスの全部又は一部を廃止するものとし、本サービスを廃止する旨及び廃止日をお客様に通知（ただし、第２号の事由に基づく場合を除きます。）するものとします。当社は、廃止日をもって利用契約の全部又は一部を解除するものとします。
      ol
        li 本サービスの廃止を決定し廃止日の３０日前までにお客様に通知した場合
        li 天災地変、停電、戦争、暴動、騒乱、労働争議その他の不可抗力により本サービスの十分な提供が困難となった場合
        li 電気通信事業者等が電気通信サービスの提供を中止又は停止することにより本サービスの十分な提供が困難となった場合

      h2 第14条（知的財産権等の取扱い）
      p 本サービス又は本商品に関する知的財産権等は全て当社又は当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービス利用の許諾は当社からお客さまへの当該知的財産権等の利用許諾を意味するものではありません。

      h2 第15条（秘密保持）
      p お客様は、当社が秘密に取り扱うことを求めて開示した本サービスに関する情報について、当社の書面による承諾がある場合を除き、第三者への開示・漏洩してはならないものとします。また、本サービス又は本商品を逆コンパイル、逆アセンブル、リバースエンジニアリングその他の方法により解析をしてはならないものとします。

      h2 第16条（情報保護）
      ol
        li 当社は、本サービスの提供に際して本商品を介して以下の情報（以下「取得情報」といいます。）を取得することがあります。
          ol
            li ① お客様の個人情報
            li ② お客様の顧客情報
            li ③ 環境情報（気温、湿度、気圧等）
            li ④ ログデータ（端末情報、時刻情報等）
        li 当社は、取得情報を本サービスの提供及び本サービスの向上のために利用し、管理します。
        li 当社は、本サービスに関連して取得したお客様の個人情報を別途定める当社のプライバシーポリシー（
          a(href="/privacy") https://cuona.io/privacy
          |） に従い適切に取り扱うものとします。
        li 当社は、以下の各場合に応じて取得情報の消去をします。
          ol
            li ① お客様がレンタルしている本商品を当社に返却された場合、当該返却された本商品のみを介して取得したログデータについて、返却日から１ヶ月以内に専用サーバから消去します。
            li ② お客様の解約等によりユーザ登録が抹消された場合、当該お客様に対する本サービスの提供にあたって取得した一切の取得情報について、抹消日から１ヶ月以内に専用サーバから消去します。
            li ③ その他当社が消去すべきと判断した場合、お客様の取得情報について適宜専用サーバから消去します。

      h2 第17条（免責）
      ol
        li 当社は、本サービスの提供の中断、停止、終了、利用不能又は変更、本サービスのダウンロード又は利用による携帯端末の故障又は損傷、本商品の利用不能その他本サービスに関してお客様が被った損害につき賠償する責任を一切負わないものとします。
        li 天災地変、戦争・内乱・暴動、法令の改廃・制定、公権力による命令・処分、労働争議、 輸送機関・通信回線の事故、原材料・運賃の高騰、為替の大幅な変動その他当社の責めに帰 すことのできない不可抗力による利用契約の全部又は一部の履行遅滞、履行不能又は不完 全履行については、当社は責任を負わないものとします。
        li 本規約において当社が賠償責任を負わないとされている場合を除き、本サービスの利用に関連してお客様が何らかの損害を被った場合、当社は、当該損害について故意重過失がある場合に限り、お客様の被った直接かつ通常の損害について賠償責任を負います。但し、当社が損害賠償を負う場合における賠償額は、お客様が当該損害発生時までに当社に支払済み利用料金の１２ヶ月分に相当する金額（支払済み利用料金が12ヶ月分に満たない場合は実支払済み利用料金相当額）を上限とします。
        li 前項の規定は、本規約において当社が賠償責任を負わないとされている条項の全部又は一部が無効とされたとしても、当社の賠償義務及び賠償上限額として適用されるものとします。

      h2 第18条（再委託）
      p 当社は、お客様に対する本サービスの提供に関して必要となる業務の全部又は一部を当社の判断にて第三者に再委託することができます。この場合、当社は、当該再委託先（以下「再委託先」といいます。）に対し、第16条(個人情報保護)のほか当該再委託業務遂行について利用契約所定の当社の義務と同等の義務を負わせるものとします。

      h2 第19条（利用契約の契約期間）
      ol
        li 利用契約の契約期間は、お客様がユーザ登録した契約開始日からお客様が解約をした日までとします。
        li 利用契約は契約期間中に解約する場合、お客様は解約日の1ヶ月前までに当社又は販売店にメール、電話、その他の方法で連絡しなければならないものとします。かかる連絡をもって、当社は利用契約の解約手続を行い、利用契約は終了するものとします。
        li 前項の定めに拘わらず、お客様は、ユーザ登録した契約開始日から2年の期間内に限り、解約した場合、解約日から同期間満了日までの残期間に対応する月額費用の総額を解約料として支払わなければならないものとします。

      h2 第20条（権利義務の譲渡）
      p お客様は、当社の書面による事前の承諾を得ない限り、本規約に基づく権利又は義務を、全部であるか一部であるかを問わず、第三者に譲渡し、引受けさせ、担保に供し、その他如何なる態様によっても処分することができないものとします。お客様は、当社がお客様に通知することにより、本サービスのお客様としての地位及びに利用契約に基づく権利又は義務を、全部であるか一部であるかを問わず、第三者へ譲渡、引受け、担保設定、その他如何なる態様による処分も実施できることを承諾します。

      h2 第21条 （協議）
      p 本規約に規定のない事項及び規定された項目について疑義が生じた場合は当社及びお客様は誠意をもって協議の上解決することとします。なお、本規約の何れかの部分が無効である場合でも、本規約全体の有効性には影響がないものとし、かかる無効の部分については、当該部分の趣旨に最も近い有効な規定を無効な部分と置き換えるものとします。

      h2 第22条 （合意管轄）
      p 本規約に関して生じた一切の争訟については、東京簡易裁判所又は東京地方裁判所をもって第一審の専属的合意管轄裁判所とします。

      h2 第23条 （準拠法）
      p.last 利用契約の成立、効力、履行及び解釈に関する準拠法は、日本法とします。

      h3 附則
      ol.zero-list
        li 2019 年 8月15日改訂
        li 2019 年 5月 8日施行
        li 2019 年 2月 1日制定

  publicFooter

</template>

<script>
import Header from '../public/Header.vue'
import Footer from '../public/Footer.vue'

export default {
  data() {
    return {

    }
  },
  title() {
    return this.$t('footer_menus.terms')
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.terms {
  width: 900px;
  margin: 0 auto;
  font-size: 14px;

  h1 {
    font-size: 28px;
    text-align: center;
    margin-bottom: 40px;
  }

  h2 {
    font-size: 18px;
    font-weight: normal;
    margin: 20px 0 10px 0;
  }

  h3 {
    font-size: 16px;
    font-weight: normal;
  }

  & > ul {
    margin: 5px auto;
  }
  & > ul > li {
    margin-bottom: 5px;
  }

  & > ol {
    margin-left: 0;
    padding-left: 18px;

    > li {
      margin-bottom: 3px;
    }
  }

  & > ol > li > ol {
    list-style: none;
    font-size: 14px;
    margin-left: 30px;
    padding-left: 0;
    ol {
      margin-left: 40px;
      padding-left: 0;
    }
  }

  .list {
    list-style: none;
    margin-bottom: 10px;
    margin-top: 5px;
  }
  .zero-list {
    list-style: none;
    margin: 0 0 20px 0;
    padding-left: 0;
  }

  p.description {
    text-indent: 14px;
  }
  p.last {
    margin-bottom: 30px;
  }

  p.go {
    margin-top: 50px;
    font-size: 14px;
  }
}
</style>

